// extracted by mini-css-extract-plugin
module.exports = {"container":"_2HhGIzP0IbtJCBVN8qWAYo","showcase":"_2_lTRPoSvUzCqyNGQ6K2eP","video":"_19Bmer4Vz48zkYNv10FS2y","feature":"_2yum9gCm_H2qq8O0lYXtEj"};